import React from "react";
import { Dialog } from "@mui/material";
import UploadStuff from ".";
import { X } from "lucide-react";
import useFileTrayStore from "./useFileTrayStore";
const GlobalUploadDialog: React.FC = () => {
  const { globalUploadDialog, closeGlobalUploadDialog } = useFileTrayStore();

  const handleClose = () => {
    closeGlobalUploadDialog();
  };

  if (!globalUploadDialog.isOpen) {
    return null;
  }

  return (
    <Dialog open={globalUploadDialog.isOpen} onClose={handleClose}>
      <div className="rounded-t-lg">
        <div className="p-4 bg-gray-500 text-white rounded-t-sm flex items-center justify-between">
          <span>Upload Files</span>
          <X
            className="w-6 h-6 cursor-pointer rounded-full p-1 hover:bg-gray-400 transition-all duration-300"
            onClick={handleClose}
          />
        </div>
        <div className="p-8">
          <UploadStuff
            multiple={true}
            selectables={["file", "folder"]}
            prependFilePath={globalUploadDialog.prependFilePath}
            metaData={globalUploadDialog.metaData}
            closeDialog={handleClose}
            driveSelection={globalUploadDialog.driveSelection}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default GlobalUploadDialog;
